/**
 * Centralized OculusService e-waste API resource paths and shared
 * request constants used by the /os/* e-waste API wrappers in
 * src/commons/api/.
 */
export const EWASTE_API_PATHS = Object.freeze({
    SEARCH_CONTAINERS: "/os/searchEWasteContainers",
    CLOSE_CONTAINER:   "/os/closeEWasteContainer",
    CREATE_CONTAINER:  "/os/createEWasteContainer",
    SEARCH_ITEMS:      "/os/searchEWasteItems",
    CREATE_ITEM:       "/os/createEWasteItem",
    GET_BATCH_WTN_PRESIGNED_URLS: "/os/getBatchWasteTransferNotePreSignedUrls",
});

export const HTTP_METHOD = Object.freeze({
    POST: "post"
});

export const PROCESS_NAME = Object.freeze({
    OCULUS: "oculus"
});



// WEBPACK FOOTER //
// ./src/commons/constants/EWasteApiPaths.js